module.exports = __webpack_public_path__ + "static/cercazone_centro5-18df1111f2f6f310a12d1117fa20877a.jpg";